export const ARTICLE_LIST = 'ARTICLE_LIST';
export const ARTICLE_DETAIL = 'ARTICLE_DETAIL';